import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import LeadershipCard from '../../components/Main/LeadershipCard'
import ImageCallout from '../../components/Main/ImageCallout'
import CtaBanner from '../../components/Main/CtaBanner'

import { getWpLeaderpage, getSomeLeaders } from '../../data/leadership'

export default function Leadership (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Leadership founders
    founders_heading: foundersHeading,
    founders_paragraph: foundersParagraph,
    founders_staff: foundersStaff, //repeater with founders_staff_image, founders_staff_name, founders_staff_title, founders_staff_page_link

    //Directors Repeater
    directors_heading: directorsHeading,
    directors: directors, //director_name, director_title, director_image, director_bio inside

    //Executive Advisory board
    advisers_heading: advisersHeading,
    advisers: advisers,

    //Junior Advisory board
    junior_advisers_heading: juniorHeading,
    junior_advisers: juniorAdvisers,

    //Callout Upper
    callout_upper_images: calloutImages, //repeater with image inside
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //callout_about_image:
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //callout_lower_image:
    callout_lower_image: { url: lowerImageUrl },
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    callout_lower_link: { url: lowerUrl, title: lowerLinkTitle },
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.page.leader.acf

  return (
    <React.Fragment>
      <Header
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug='/leadership'
      />

      <main id='content'>
      <a className='skip' id='skip'></a>
        <LeadershipCard
          founders
          title={foundersHeading}
          body={foundersParagraph}
          content={foundersStaff}
        />
        <ImageCallout
          reversed
          array
          title={calloutHeading}
          body={calloutParagraph}
          link={calloutUrl}
          button={calloutLinkTitle}
          images={calloutImages}
        />
        <LeadershipCard modal directors title={directorsHeading} content={directors} />
        <LeadershipCard advisers title={advisersHeading} content={advisers} />
        <LeadershipCard juniorAdvisers title={juniorHeading} content={juniorAdvisers} />
        <ImageCallout
          title={lowerHeading}
          body={lowerParagraph}
          link={lowerUrl}
          button={lowerLinkTitle}
          image={lowerImageUrl}
        />
      </main>
      <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />

      <Footer />
    </React.Fragment>
  )
}

export async function getStaticProps ({ preview = false }) {
  const page = {
    leader: await getWpLeaderpage(),
    leaders: await getSomeLeaders()
  }

  return {
    props: {
      page
    }
  }
}
